module.exports = function(gettextCatalog) {
  return {
    defaultBillingType: 'patient',
    billingTypes: [
      {
        value: 'patient',
        label: gettextCatalog.getString('Patient Invoice'),
      },
      {
        value: 'tariff590-insurance',
        label: gettextCatalog.getString('Insurance Reclaim Slip'),
      },
      {
        value: 'tariff590-patient',
        label: gettextCatalog.getString('Patient Reclaim Slip'),
      },
    ],
  };
};



// WEBPACK FOOTER //
// ./src/app/common/invoiceExportOptions.js